import { useSearchParams } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import EventExplorer from "@/components/feature/EventExplorer";
import { Breadcrumb } from "@/components/base/Ui";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function SearchPage() {
  const [params] = useSearchParams();
  const query = params.get("q") ?? "";

  useDocumentMeta({
    title: query ? `“${query}”搜索结果 - 51-每日大赛` : "搜索结果 - 51-每日大赛",
    description: `51-每日大赛搜索结果${query ? `：${query}` : ""}，按赛事名称、队伍或关键词检索每日赛事资讯与比赛安排。`,
    keywords: `搜索,${query},赛事资讯,比赛安排,51-每日大赛`,
  });

  return (
    <Layout>
      <div className="mx-auto w-full px-4 py-8 md:px-6">
        <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "搜索结果" }]} />

        <header className="mt-5 rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
          <div className="flex items-start gap-4">
            <span className="flex h-14 w-14 items-center justify-center rounded-xl bg-primary-100 text-2xl text-primary-700">
              <i className="ri-search-line"></i>
            </span>
            <div>
              <h1 className="text-2xl font-extrabold tracking-tight text-foreground-950 md:text-3xl">
                搜索结果
              </h1>
              <p className="mt-2 text-sm text-foreground-600">
                {query ? (
                  <>
                    关键词 <span className="font-bold text-accent-700">“{query}”</span> 的匹配结果如下。
                  </>
                ) : (
                  "请输入赛事名称、队伍或关键词进行检索。"
                )}
              </p>
            </div>
          </div>
          <p className="mt-4 rounded-md bg-secondary-50 px-3 py-2 text-xs text-secondary-800">
            <i className="ri-information-line"></i> 搜索为前端演示实现，仅匹配站内示例数据。
          </p>
        </header>

        <div className="mt-6">
          <EventExplorer query={query} />
        </div>
      </div>
    </Layout>
  );
}